import { useAtom } from "jotai";
import { useCallback } from "react";
import { recentSearchesAtom } from "../store/searchAtoms";

const MAX_RECENT = 8;

// Indirection over recentSearchesAtom so we can later swap localStorage for
// a backend-backed source by changing only this hook. UI consumers stay the
// same.
export const useRecentSearches = () => {
    const [items, setItems] = useAtom(recentSearchesAtom);

    const push = useCallback(
        (term: string) => {
            const trimmed = term.trim();
            if (!trimmed) return;
            setItems((prev) => {
                const lowered = trimmed.toLowerCase();
                const without = prev.filter(
                    (t) => t.toLowerCase() !== lowered,
                );
                return [trimmed, ...without].slice(0, MAX_RECENT);
            });
        },
        [setItems],
    );

    const clear = useCallback(() => setItems([]), [setItems]);

    return { items, push, clear };
};
